"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getConfig;

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var _store = _interopRequireDefault(require("../store/store"));

var NotificationSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var config = {
  common: {
    ANS_APP_ID: 'ExcPulse',
    ADOBE_IO_API_KEY: 'exc-pulse'
  },
  dev: {
    ANS_HOST: Constants.ANS_STAGE_ENDPOINT,
    ANS_LONG_POLL_HOST: Constants.LONG_POLL_STAGE_ENDPOINT,
    SKMS_HOST: Constants.SKMS_STAGE_ENDPOINT,
    ADOBE_STATUS_HOST: Constants.ADOBE_STATUS_QA_ENDPOINT
  },
  qa: {
    ANS_HOST: Constants.ANS_STAGE_ENDPOINT,
    ANS_LONG_POLL_HOST: Constants.LONG_POLL_STAGE_ENDPOINT,
    SKMS_HOST: Constants.SKMS_STAGE_ENDPOINT,
    ADOBE_STATUS_HOST: Constants.ADOBE_STATUS_QA_ENDPOINT
  },
  test: {
    ANS_HOST: Constants.ANS_STAGE_ENDPOINT,
    ANS_LONG_POLL_HOST: Constants.LONG_POLL_STAGE_ENDPOINT,
    SKMS_HOST: Constants.SKMS_STAGE_ENDPOINT,
    ADOBE_STATUS_HOST: Constants.ADOBE_STATUS_QA_ENDPOINT
  },
  stage: {
    ANS_HOST: Constants.ANS_STAGE_ENDPOINT,
    ANS_LONG_POLL_HOST: Constants.LONG_POLL_STAGE_ENDPOINT,
    SKMS_HOST: Constants.SKMS_STAGE_ENDPOINT,
    ADOBE_STATUS_HOST: Constants.ADOBE_STATUS_STAGE_ENDPOINT
  },
  prod: {
    ANS_HOST: Constants.ANS_ENDPOINT,
    ANS_LONG_POLL_HOST: Constants.LONG_POLL_ENDPOINT,
    SKMS_HOST: Constants.SKMS_ENDPOINT,
    ADOBE_STATUS_HOST: Constants.ADOBE_STATUS_ENDPOINT
  }
};
/**
 * Get a configuration value for pulse. Provides environment specific value if overridden.
 * @param {string} key Pulse Config Key
 * @param {string} def Default Pulse Config Value
 * @param {string} env Pulse Environment (Optional)
 * @returns {string} Pulse Config Value
 */

function getConfig(key) {
  var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (config[env || NotificationSelectors.getEnvironment(_store.default.getState())] || {})[key] || config.common[key] || def;
}